<!-- Operaciones de Conjuntos -->
@if (showContent) {
<div class="pt-4 border-t border-gray-200 dark:border-gray-700">
  <div class="flex items-start justify-between gap-3 mb-3">
    <div>
      <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Operaciones de Conjuntos</h3>
      <p class="text-sm text-gray-500 dark:text-gray-400">Combinaciones aplicadas sobre este segmento</p>
    </div>
    @if (showButton) {
    <button (click)="openModal()"
      class="shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-orange-600 bg-orange-50 dark:bg-orange-900/20 dark:text-orange-400 rounded-lg hover:bg-orange-100 dark:hover:bg-orange-900/30 transition-colors border border-orange-200 dark:border-orange-800">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
      </svg>
      Nueva operación
    </button>
    }
  </div>
  @if (existingSetOps.length > 0) {
  <div class="space-y-2">
    @for (op of existingSetOps; track op.id) {
    <div class="flex items-center gap-3 px-3 py-2.5 bg-gray-50 dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700/50 text-sm">
      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-50 text-orange-700 dark:bg-orange-900/20 dark:text-orange-400">
        {{ getOpLabel(op.operationType) }}
      </span>
      <span class="font-medium text-gray-800 dark:text-gray-200">{{ op.segmentSourceName }}</span>
      <span class="ml-auto text-xs text-gray-400 dark:text-gray-500">Orden: {{ op.executionOrder }}</span>
    </div>
    }
  </div>
  } @else {
  <p class="text-sm text-gray-400 dark:text-gray-500">Sin operaciones de conjuntos aplicadas.</p>
  }
</div>
}

<!-- Modal -->
<app-modal [isOpen]="isModalOpen" (close)="closeModal()" [showCloseButton]="false" className="max-w-lg mx-4">
  <div class="p-6">
    <div class="flex items-center gap-3 mb-6">
      <div class="p-2 bg-orange-50 dark:bg-orange-900/20 rounded-xl">
        <svg class="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
        </svg>
      </div>
      <div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">Operación de Conjuntos</h3>
        <p class="text-xs text-gray-500 dark:text-gray-400">Combina miembros de otros segmentos en este</p>
      </div>
    </div>

    <div class="space-y-5">
      <!-- Tipo de operación -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de operación</label>
        <div class="grid grid-cols-3 gap-2">
          @for (op of [{value: 'UNION', label: 'Unión', sub: 'A + B'}, {value: 'INTERSECT', label: 'Intersección', sub: 'A ∩ B'}, {value: 'DIFFERENCE', label: 'Diferencia', sub: 'A - B'}]; track op.value) {
          <button type="button" (click)="onOpTypeChange($any(op.value))"
            [ngClass]="setOpType === op.value
              ? 'bg-orange-500 text-white border-orange-500'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'"
            class="px-3 py-2.5 text-sm font-medium rounded-xl border transition-colors text-center">
            <span class="block text-xs font-bold">{{ op.label }}</span>
            <span class="block text-[10px] mt-0.5 opacity-70">{{ op.sub }}</span>
          </button>
          }
        </div>
      </div>

      <!-- UNIÓN / INTERSECCIÓN: lista simple -->
      @if (setOpType !== 'DIFFERENCE') {
      <div>
        @if (setOpType === 'UNION') {
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">
          Combina todos los miembros de los segmentos seleccionados <span class="font-semibold text-gray-700 dark:text-gray-300">sin duplicados</span>. Un contacto aparece en el resultado si está en <span class="font-semibold text-gray-700 dark:text-gray-300">cualquiera</span> de los segmentos fuente.
        </p>
        } @else {
        <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">
          Solo incluye los miembros presentes en <span class="font-semibold text-gray-700 dark:text-gray-300">todos</span> los segmentos seleccionados. Un contacto aparece en el resultado únicamente si está en <span class="font-semibold text-gray-700 dark:text-gray-300">cada uno</span> de los segmentos fuente.
        </p>
        }
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Seleccionar segmentos fuente</label>
        <div class="space-y-1.5 max-h-48 overflow-y-auto custom-scrollbar border border-gray-200 dark:border-gray-700 rounded-xl p-2">
          @if (availableSegments.length === 0) {
            <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">No hay otros segmentos disponibles</p>
          }
          @for (seg of availableSegments; track seg.id) {
          <button (click)="toggleSource(seg.id)"
            class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-left transition-colors"
            [ngClass]="isSelected(seg.id)
              ? 'bg-orange-50 dark:bg-orange-900/10 border border-orange-300 dark:border-orange-700'
              : 'hover:bg-gray-50 dark:hover:bg-gray-800 border border-transparent'">
            <div class="w-5 h-5 rounded border-2 flex items-center justify-center transition-colors shrink-0"
              [ngClass]="isSelected(seg.id) ? 'bg-orange-500 border-orange-500' : 'border-gray-300 dark:border-gray-600'">
              @if (isSelected(seg.id)) {
                <svg class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                </svg>
              }
            </div>
            <div class="min-w-0 flex-1">
              <span class="block text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{ seg.name }}</span>
              <span class="block text-[10px] text-gray-400 dark:text-gray-500">{{ seg.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }} · {{ seg.totalContacts }} miembros</span>
            </div>
          </button>
          }
        </div>
      </div>
      }

      <!-- DIFERENCIA: zona A y zona B -->
      @if (setOpType === 'DIFFERENCE') {
      <div class="space-y-3">
        <p class="text-xs text-gray-500 dark:text-gray-400">
          Selecciona un segmento base <span class="font-semibold text-gray-700 dark:text-gray-300">A</span> y uno o más segmentos a restar <span class="font-semibold text-gray-700 dark:text-gray-300">B</span>. El resultado serán los miembros de A que no estén en B.
        </p>

        <!-- Zona A: base (radio) -->
        <div>
          <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5">
            Base (A) <span class="ml-1 normal-case font-normal">— un solo segmento</span>
          </p>
          <div class="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden max-h-36 overflow-y-auto custom-scrollbar">
            @if (availableSegments.length === 0) {
              <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">No hay segmentos disponibles</p>
            }
            @for (seg of availableSegments; track seg.id) {
            <button type="button" (click)="toggleBase(seg.id)"
              class="w-full flex items-center gap-3 px-3 py-2.5 text-left transition-colors border-b border-gray-100 dark:border-gray-800 last:border-0"
              [class.bg-orange-50]="baseSegmentId === seg.id"
              [class.dark:bg-orange-900/10]="baseSegmentId === seg.id"
              [class.hover:bg-gray-50]="baseSegmentId !== seg.id"
              [class.dark:hover:bg-gray-800]="baseSegmentId !== seg.id">
              <div class="w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors"
                [class.bg-orange-500]="baseSegmentId === seg.id"
                [class.border-orange-500]="baseSegmentId === seg.id"
                [class.border-gray-300]="baseSegmentId !== seg.id"
                [class.dark:border-gray-600]="baseSegmentId !== seg.id">
                @if (baseSegmentId === seg.id) {
                  <div class="w-1.5 h-1.5 rounded-full bg-white"></div>
                }
              </div>
              <div class="min-w-0 flex-1">
                <span class="block text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{ seg.name }}</span>
                <span class="block text-[10px] text-gray-400 dark:text-gray-500">{{ seg.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }} · {{ seg.totalContacts }} miembros</span>
              </div>
            </button>
            }
          </div>
        </div>

        <!-- Zona B: restar (checkboxes, excluye el base) -->
        <div>
          <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5">
            Restar (B) <span class="ml-1 normal-case font-normal">— uno o más segmentos</span>
          </p>
          <div class="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden max-h-36 overflow-y-auto custom-scrollbar">
            @if (availableSegments.length === 0) {
              <p class="text-sm text-gray-400 dark:text-gray-500 text-center py-4">No hay segmentos disponibles</p>
            }
            @for (seg of availableSegments; track seg.id) {
            <button type="button" (click)="toggleSubtract(seg.id)"
              [disabled]="seg.id === baseSegmentId"
              class="w-full flex items-center gap-3 px-3 py-2.5 text-left transition-colors border-b border-gray-100 dark:border-gray-800 last:border-0 disabled:opacity-40 disabled:cursor-not-allowed"
              [class.bg-orange-50]="subtractIds.includes(seg.id)"
              [class.dark:bg-orange-900/10]="subtractIds.includes(seg.id)"
              [class.hover:bg-gray-50]="!subtractIds.includes(seg.id) && seg.id !== baseSegmentId"
              [class.dark:hover:bg-gray-800]="!subtractIds.includes(seg.id) && seg.id !== baseSegmentId">
              <div class="w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 transition-colors"
                [class.bg-orange-500]="subtractIds.includes(seg.id)"
                [class.border-orange-500]="subtractIds.includes(seg.id)"
                [class.border-gray-300]="!subtractIds.includes(seg.id)"
                [class.dark:border-gray-600]="!subtractIds.includes(seg.id)">
                @if (subtractIds.includes(seg.id)) {
                  <svg class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                  </svg>
                }
              </div>
              <div class="min-w-0 flex-1">
                <span class="block text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{ seg.name }}</span>
                <span class="block text-[10px] text-gray-400 dark:text-gray-500">{{ seg.type === 'DYNAMIC' ? 'Dinámica' : 'Estática' }} · {{ seg.totalContacts }} miembros</span>
              </div>
            </button>
            }
          </div>
        </div>
      </div>
      }
    </div>

    <div class="flex justify-end gap-3 mt-6">
      <button (click)="closeModal()"
        class="px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
      <button (click)="ejecutar()" [disabled]="isExecuting || !canExecute"
        class="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-orange-500 rounded-xl hover:bg-orange-600 transition-colors disabled:opacity-50">
        @if (isExecuting) {
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        }
        Ejecutar
      </button>
    </div>
  </div>
</app-modal>
